import Rails from 'rails-ujs'
import { Application } from '@hotwired/stimulus'

if (!window._rails_loaded) {
  Rails.start()
}

const application = Application.start()
application.debug = false
window.Stimulus = application

import controllers, { filenames } from './controllers/**/*_controller.js'

controllers.forEach((module, index) => {
  const identifier = filenames[index]
    .replace(/^.*\/controllers\//, '')
    .replace(/_controller\.js$/, '')
    .replaceAll('_', '-')
    .replaceAll('/', '--')

  application.register(identifier, module.default)
})
